<div class="single-project-page" *ngIf="project" >
    <!-- Hero Section -->
    <section class="hero-section" id="single-project-banner">
        <div class="hero-overlay"></div>
        <img [src]="project.imageUrl" [alt]="project.title" class="hero-image">
        <div class="hero-content">
            <div class="container">
                <span class="project-category">{{ project.businessArea }}</span>
                <h1 class="project-title">{{ project.title }}</h1>
                <div class="project-meta">
                    <div class="meta-item">
                        <i class="pi pi-map-marker"></i>
                        <span>{{ project.location }}</span>
                    </div>
                    <div class="meta-item">
                        <i class="pi pi-calendar"></i>
                        <span>{{ project.dateCompleted }}</span>
                    </div>
                    <div class="meta-item">
                        <i class="pi pi-building"></i>
                        <span>{{ project.areaSqM }} m²</span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Main Content -->
    <section class="project-content">
        <div class="container">
            <div class="content-grid">
                <!-- Left Column: Description & Details -->
                <div class="left-column">
                    <!-- Client Info -->
                    <div class="client-card">
                        <h2 class="client-title">¿Quién Confió en nosotros?</h2>
                        <div class="client-info-container">
                            <div class="client-logo">
                                <img [src]="project.clientLogoUrl" [alt]="project.client">
                            </div>
                            <div class="client-info">
                                <p class="client-name">{{ project.client }}</p>
                                <p class="client-label">{{ project.location }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Description -->
                    <div class="description-section">
                        <h2 class="section-title">Acerca del Proyecto</h2>
                        <p class="project-description">{{ project.description }}</p>
                    </div>

                    <!-- Project Details -->
                    <div class="details-section">
                        <h2 class="section-title">Detalles del Proyecto</h2>
                        <div class="details-grid">
                            <div class="detail-item">
                                <i class="pi pi-tag"></i>
                                <div class="detail-content">
                                    <span class="detail-label">Sector</span>
                                    <span class="detail-value">{{ project.businessArea }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <i class="pi pi-map-marker"></i>
                                <div class="detail-content">
                                    <span class="detail-label">Ubicación</span>
                                    <span class="detail-value">{{ project.location }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <i class="pi pi-calendar"></i>
                                <div class="detail-content">
                                    <span class="detail-label">Fecha de Finalización</span>
                                    <span class="detail-value">{{ project.dateCompleted }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <i class="pi pi-building"></i>
                                <div class="detail-content">
                                    <span class="detail-label">Área Total</span>
                                    <span class="detail-value">{{ project.areaSqM }} m²</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column: Gallery -->
                <div class="right-column">
                    <div class="gallery-section">
                        <h2 class="section-title">Galería de Imágenes</h2>

                        <!-- Main Image -->
                        <div class="main-image-container" (click)="openImageModal(selectedImageIndex)">
                            <img [src]="project.imagesGallery[selectedImageIndex]" [alt]="project.title"
                                class="main-image">
                            <div class="image-overlay">
                                <i class="pi pi-search-plus"></i>
                            </div>
                        </div>

                        <!-- Thumbnails -->
                        <div class="thumbnails-container">
                            <div *ngFor="let image of project.imagesGallery; let i = index" class="thumbnail"
                                [class.active]="i === selectedImageIndex" [class.hidden]="i >= maxVisibleThumbnails"
                                (click)="selectImage(i)">
                                <img [src]="image" [alt]="'Imagen ' + (i + 1)">
                            </div>

                            <!-- Mostrar "+n fotos" si hay más imágenes -->
                            <div *ngIf="project.imagesGallery.length > maxVisibleThumbnails"
                                class="thumbnail more-photos" (click)="openImageModal(maxVisibleThumbnails)">
                                <div class="more-photos-overlay">
                                    <span>+{{ project.imagesGallery.length - maxVisibleThumbnails }}</span>
                                    <span class="photos-text">fotos</span>
                                </div>
                                <img [src]="project.imagesGallery[maxVisibleThumbnails]" [alt]="'Ver más fotos'">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Image Modal -->
    <div class="image-modal" *ngIf="isImageModalOpen" (click)="closeImageModal()">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <!-- Close Button -->
            <button class="close-btn" (click)="closeImageModal()" title="Cerrar (Esc)">
                <i class="pi pi-times"></i>
            </button>

            <!-- Navigation Buttons -->
            <button class="nav-btn prev-btn" (click)="previousImage()" title="Anterior (←)">
                <i class="pi pi-chevron-left"></i>
            </button>
            <button class="nav-btn next-btn" (click)="nextImage()" title="Siguiente (→)">
                <i class="pi pi-chevron-right"></i>
            </button>

            <!-- Zoom Controls -->
            <div class="zoom-controls">
                <button class="zoom-btn" (click)="zoomOut()" [disabled]="zoomLevel <= minZoom" title="Alejar (-)">
                    <i class="pi pi-minus"></i>
                </button>
                <span class="zoom-level">{{ (zoomLevel * 100).toFixed(0) }}%</span>
                <button class="zoom-btn" (click)="zoomIn()" [disabled]="zoomLevel >= maxZoom" title="Acercar (+)">
                    <i class="pi pi-plus"></i>
                </button>
                <button class="zoom-btn" (click)="resetZoom()" [disabled]="zoomLevel === 1" title="Restablecer">
                    <i class="pi pi-refresh"></i>
                </button>
            </div>

            <!-- Image Container -->
            <div class="image-container"
                 (mousedown)="onImageMouseDown($event)"
                 (mousemove)="onImageMouseMove($event)"
                 (mouseup)="onImageMouseUp()"
                 (mouseleave)="onImageMouseUp()"
                 (touchstart)="onTouchStart($event)"
                 (touchmove)="onTouchMove($event)"
                 (touchend)="onTouchEnd($event)"
                 [class.dragging]="isDragging"
                 [class.zoomed]="zoomLevel > 1">
                <img [src]="project.imagesGallery[selectedImageIndex]" 
                     [alt]="project.title" 
                     class="modal-image"
                     [style.transform]="getImageTransform()"
                     draggable="false">
            </div>

            <!-- Image Counter -->
            <div class="image-counter">
                <span class="counter-text">{{ selectedImageIndex + 1 }} / {{ project.imagesGallery.length }}</span>
            </div>

            <!-- Keyboard Hints -->
            <div class="keyboard-hints">
                <span><kbd>←</kbd> <kbd>→</kbd> Navegar</span>
                <span><kbd>+</kbd> <kbd>-</kbd> Zoom</span>
                <span><kbd>Esc</kbd> Cerrar</span>
            </div>
        </div>
    </div>

    <!-- Similar Projects Section -->
    <section class="similar-projects-section" *ngIf="similarProjects.length > 0">
        <div class="container">
            <h2 class="section-title">Proyectos similares</h2>
            <div class="similar-projects-grid">
                <div class="project-card" *ngFor="let similarProject of similarProjects"
                    (click)="navigateToProject(similarProject.id, similarProject.title)">
                    <div class="project-image">
                        <img [src]="similarProject.imageUrl" [alt]="similarProject.title">
                        <div class="project-overlay">
                            <span class="view-text">Ver proyecto</span>
                        </div>
                    </div>
                    <div class="project-info">
                        <span class="project-category">{{ similarProject.businessArea }}</span>
                        <h3 class="project-name">{{ similarProject.title }}</h3>
                        <p class="project-location">
                            <i class="pi pi-map-marker"></i>
                            {{ similarProject.location }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>